var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition-group",
    { staticClass: "k-actions actions", attrs: { name: "fade", tag: "div" } },
    [
      _vm._l(_vm.actions, function (action) {
        return [
          _vm.actionPasses(action) && (action.icon || action.label)
            ? _c(
                "w-btn",
                {
                  key: action.name,
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.doAction(action)
                    },
                  },
                },
                [
                  action.label && _vm.type.startsWith("text")
                    ? _c("span", [_vm._v(_vm._s(action.label))])
                    : _vm._e(),
                  _vm.icons[action.icon] && _vm.type.match("icon")
                    ? _c(_vm.icons[action.icon], {
                        tag: "component",
                        staticClass: "icon",
                        attrs: { title: action.label },
                      })
                    : _vm._e(),
                  action.label && _vm.type === "icon-text"
                    ? _c("span", [_vm._v(_vm._s(action.label))])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
        ]
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }